import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostBinding } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink, } from '@angular/router';
import moment from 'moment';
import { EmptyObject, WebUtils } from '../common/utils';
import { AccessUtils, TBooking } from '../core/entities';
import { SiteLangMixin } from '../core/lang';
import { SessionService } from '../session.service';
import { SiteFormatMixin } from '../thinkdesks/site.format.mixin';
import { TBookingStatus } from '../thinkdesks/thinkdesks.entities';
import { QRCodeWidget } from './qrcode.widget';
import { SpaceCard } from "./space.card";

@Component({
  selector: 'app-booking-invite-page',
  standalone: true,
  imports: [CommonModule, QRCodeWidget, SpaceCard, RouterLink,],
  templateUrl: './booking.invite.page.html',
})
export class BookingInvitePage extends SiteLangMixin(SiteFormatMixin(EmptyObject)) {
  _common = _common;
  @HostBinding('class') css = 'max-scroll';
  code = '';
  nowTime: moment.Moment;
  statusList = TBookingStatus;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    public override session: SessionService,
    private route: ActivatedRoute,
    private router: Router,

  ) {
    super();



  }
  isOwner = false;
  ngOnInit() {
    if (!this.session.user) {

      let params = new URLSearchParams(window.location.search);
      let authCode = params.get('authCode');
      let source = params.get('source');

      if (source == 'app' && authCode) {
        this.session.vpLogin(authCode, () => {
          this.refresh();
        })
      } else {


        let code = this.route.snapshot.paramMap.get('code');
        let url = this.session.path('/invite-detail/' + code + '/login')
        this.router.navigate([url])
        this.nowTime = moment();
      }


      return
    }

    this.refresh();
  }
  ngOnDestroy() {

  }

  hash: string;
  object: TBooking;
  refresh() {
    let code = this.route.snapshot.paramMap.get('code');
    if (!code) {
      this.router.navigate([this.session.path('/')]);
      return
    }
    let parts = code.split('-');
    if (parts.length != 2) {
      this.router.navigate([this.session.path('/')]);
      return
    }
    let id = parseInt(parts[0]);
    this.hash = parts[1];
    let url = `/api/client/booking/${id}/invite/${this.hash}`;
    WebUtils.web_result(
      this.http.get(url),
      (result) => {

        this.object = result;
        AccessUtils.fixBooking(this.object);
        this.isOwner = this.object.member.id == this.session.user.id

      },
      null,
      (err) => {
        this.router.navigate([this.session.path('/')]);
      }
    );

  }
  next() {
    let code = this.route.snapshot.paramMap.get('code');
    let url = this.session.path('/invite-detail/' + code + '/confirm')
    this.router.navigate([url])

  }
  accept() {
    WebUtils.web_result(this.http.post(`/api/client/booking/${this.object.id}/accept/${this.hash}`, {

    }), (result) => {
      this.router.navigate([
        this.session.path(
          `/my/booking/${this.object.id}`)]);
    }, this.snackBar,
      (err) => {
        if (err == 'capacity.exceeded') {
          let code = this.route.snapshot.paramMap.get('code');
          let url = this.session.path('/invite-detail/' + code + '/exceeded')
          this.router.navigate([url])
        } else if (err == 'already.accepted') {
        } else if (err == 'booking.cancelled') {
        } else if (err == 'booking.ended') {

        }
      });
  }


}
